import { getExperienceFragmentByKey } from '.';

export const getHasLocationsByKey = (state: WtrState, experienceFragmentKey: string) => {
  const { locations } = getExperienceFragmentByKey(state, experienceFragmentKey) || {};

  return !!locations;
};
